<template>
  <section class="section is-title-bar">
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <ul>
            <li v-for="(item, index) in visibleItems" :key="index">
              <router-link
                v-if="item.to && index < visibleItems.length - 1"
                :to="item.to"
              >
                {{ item.label }}
              </router-link>
              <span v-else>{{ item.label }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TitleBar",
  props: {
    titleStack: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    visibleItems() {
      return this.titleStack
        .filter((item) => {
          if (item === null || item === undefined) return false;
          if (typeof item === "string") return item !== "";
          return item.label !== "";
        })
        .map((item) => {
          if (typeof item === "string") {
            return { label: item, to: null };
          }
          return item;
        });
    },
  },
};
</script>
